import { getRightList } from '@/infrastructure/api-functions';
import type { IRightListRequest } from '@/types';
import { ListBaseService } from '@eureka/shared/solution-card';
import { type ISolutionListResponse } from '@eureka/shared/solution-card/src/types';

export class ProjectDrawerListService extends ListBaseService {
    protected fetchData(
        data: IRightListRequest
    ): Promise<ISolutionListResponse> {
        return getRightList(data)
    }
}
